import dayjs from 'dayjs'

export function formatNotificationRowTime(ts: number): string {
  const created = dayjs.unix(ts)
  const now = dayjs()
  const minutes = now.diff(created, 'minute')

  if (minutes < 1) return 'now'
  if (minutes < 60) return `${minutes}m`

  const hours = now.diff(created, 'hour')
  if (hours < 24) return `${hours}h`

  if (created.isSame(now.subtract(1, 'day'), 'day')) return 'yesterday'

  const days = now.diff(created, 'day')
  if (days < 7) return `${days}d`

  return created.format('D MMM')
}

export function formatNotificationRowDate(ts: number, locale: string): string {
  return dayjs.unix(ts).locale(locale).format('MMM D, YYYY')
}
